<div class="container">
    <div class="row">
        <div class="col-7"></div>
        <div class="col-5">
            <form [formGroup]="form" (ngSubmit)="onSubmit()" class="mt-2">
                <label for="solicitud" class="ms-2">Buscar Solicitud</label>
                <input type="number" class="ms-2" id="solicitud"  formControlName="solicitud">
                <button type="submit" class="ms-2 btn btn-primary"><fa-icon [icon]="['fas', 'search']"></fa-icon></button>
            </form>  
        </div>
    </div>
    <div class="row">
        <h2>
            Detalle de Solicitud.
        </h2>
    </div>
    <form [formGroup]="formulario" class="row mt-3">
        <div class="form-group col-3">
            <label for="nroSol">Nro. Solicitud</label>
            <input type="text" id="nroSol" formControlName="nroSol" class="form-control">
        </div>
        <div class="form-group col-5">
            <label for="estSol">Estado Solicitud</label>
            <input type="text" id="estSol" formControlName="estSol" class="form-control">
        </div>
        <div class="form-group col-4">
            <label for="creationDate">Fecha Solicitud</label>
            <input type="text" id="creationDate" formControlName="creationDate" class="form-control"> 
        </div>
        <div class="form-group col-4">
            <label for="rutEmpr">Rut Empresa</label>
            <input type="text" id="rutEmpr" formControlName="rutEmpr" class="form-control">
        </div>
        <div class="form-group col-8">
            <label for="razonSocial">Razón Social</label>
            <input type="text" id="razonSocial" formControlName="razonSocial" class="form-control">
        </div>
        <div class="form-group col-4">
            <label for="rutRep">Rut Representante</label>
            <input type="text" id="rutRep" formControlName="rutRep" class="form-control">
        </div>
        <div class="form-group col-8">
            <label for="nombreRep">Nombre Representante</label>
            <input type="text" id="nombreRep" formControlName="nombreRep" class="form-control">
        </div>
        <div class="form-group col-12">
            <label for="correoRep">Correo Representante</label>
            <input type="text" id="correoRep" formControlName="correoRep" class="form-control">
        </div>
        <div class="form-group col-2 mt-3">
            <label for="correoRep">Archivo 1: </label>
            <fa-icon *ngIf="archivo_1 == 1" [icon]="['fas', 'file-signature']" [style.color]="'#007fff'" (click)="downloadFile1()" [size]="'2x'" class="ms-2"></fa-icon>
            <fa-icon *ngIf="archivo_1 != 1" [icon]="['fas', 'file-signature']" [style.color]="'#bebebe'" [size]="'2x'" class="ms-2"></fa-icon>
        </div>
        <div class="form-group col-2 mt-3">
            <label for="correoRep">Archivo 2: </label>
            <fa-icon *ngIf="archivo_2 == 1" [icon]="['fas', 'file-signature']" [style.color]="'#007fff'" (click)="downloadFile2()" [size]="'2x'" class="ms-2"></fa-icon>
            <fa-icon *ngIf="archivo_2 != 1" [icon]="['fas', 'file-signature']" [style.color]="'#bebebe'" [size]="'2x'" class="ms-2"></fa-icon>
        </div>
    </form>
    <div class="row" *ngIf="estado == 0">
        <div class="col-3">
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th scope="col">Aprobar</th>
                        <th scope="col">Rechazar</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="text-center"><fa-icon [icon]="['fas', 'check-circle']" style="color: #0f5132;" (click)="openModalA()" [size]="'lg'"></fa-icon></td>
                        <td class="text-center"><fa-icon [icon]="['fas', 'times-circle']" style="color: #842029;" (click)="openModalR()" [size]="'lg'"></fa-icon></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="row">
        <div class="col-2">
            <button  (click)="onBack()" class="btn btn-primary mt-3"><fa-icon [icon]="['fas', 'arrow-left']" class="me-2"></fa-icon>Volver</button>
        </div>
    </div>
</div>